/* eslint-disable no-console, class-methods-use-this, id-length */

export default class HeaderLogin {
  constructor() {
    this.selector = '.header__login--mobile';

    this.classNames = {
      popupActive: 'header__login--active',
    };
  }

  bootstrap() {
    const component = document.querySelector(this.selector);

    if (!component) {
      return;
    }

    component.addEventListener('click', event => {
      if (event.target === component ||
          event.target === component.querySelector(':scope > span') ||
          event.target === component.querySelector(':scope > span > svg') ||
          event.target === component.querySelector(':scope > span > svg > path')
      ) {
        event.preventDefault();
        component.classList.toggle(this.classNames.popupActive);
      }
    });
  }
}
